import { formatNumber } from 'helpers/utils';
import { ImpactReportData } from 'store/impactReport/types';

export const MAX_SPAM_AVOIDED_COUNT = 5000;

export interface SummaryStat {
  label: string;
  value: string;
}

export const getSpamAvoided = (spamAvoidedCount: number) => ({
  count: Math.min(spamAvoidedCount, MAX_SPAM_AVOIDED_COUNT),
  isCapped: spamAvoidedCount > MAX_SPAM_AVOIDED_COUNT,
});

// Shared by the final slide and the share image so the two can't drift.
export const getSummaryStats = (data: ImpactReportData): SummaryStat[] => {
  const spamAvoided = getSpamAvoided(data.spam_avoided_count);

  return [
    { label: 'Recipients Supported', value: String(data.recipient_count) },
    { label: 'Top Issue', value: data.issues?.length ? data.issues[0].page_name : '-' },
    {
      label: 'Candidates Elected',
      value: data.election_margin_min ? String(data.recipient_ids_winners.length) : '-',
    },
    { label: 'My Impact', value: `${data.donation_amount_multiplier}x` },
    {
      label: 'Average Impact Score',
      value: data.recipient_impact_score_average
        ? `${data.recipient_impact_score_average.toFixed(1)}/10`
        : '-',
    },
    {
      label: 'Spam Texts Avoided',
      value: `${formatNumber(spamAvoided.count)}${spamAvoided.isCapped ? '+' : ''}`,
    },
  ];
};
